import { BlockerAction } from '@cash-web/protos/squareup/franklin/blocker_action.pb'
import { BlockerAction as CDFBlockerAction } from '@squareup/customer-data-events-web'

type BlockerActionsForRecord = Omit<BlockerAction, 'text' | 'localized_text' | 'icon' | 'haptic_feedback_action'>

const blockerActionToCDFBlockerActionMap: Record<keyof BlockerActionsForRecord, CDFBlockerAction> = {
  confirmation_dialog: 'CONFIRMATION_DIALOG_FIRST',
  confirmation_sheet: 'CONFIRMATION_SHEET_FIRST',
  copy_action: 'COPY_ACTION',
  end_flow_action: 'END_FLOW_ACTION',
  menu_action: 'MENU_ACTION',
  open_url_action: 'OPEN_URL_ACTION',
  skip_blocker_action: 'SKIP_BLOCKER_ACTION',
  submit_action: 'SUBMIT_ACTION',
  internal_navigation_action: 'INTERNAL_NAVIGATION_ACTION',
  sign_out_action: 'SIGN_OUT_ACTION',
  share_action: 'SHARE_FILE_ACTION',
  view_action: 'VIEW_ACTION',
  dialog_action: 'DIALOG_ACTION',
  back_navigation_action: 'BACK_NAVIGATION_ACTION',
  share_text_action: 'SHARE_TEXT_ACTION',
  end_activity_action: 'END_ACTIVITY_WITH_RESULT_ACTION',
  change_element_text_action: 'END_FLOW_ACTION',
  delayed_action: 'DELAYED_ACTION',
  show_overlay_screen_action: 'SHOW_OVERLAY_SCREEN',
  advance_action: 'SUBMIT_ACTION',
  retreat_action: 'BACK_NAVIGATION_ACTION',
  conditional_confirmation: 'END_FLOW_ACTION',
  open_external_url_and_submit_action: 'OPEN_URL_ACTION',
}

export const blockerActionToCDFBlockerAction = (action: keyof BlockerActionsForRecord): CDFBlockerAction => {
  return blockerActionToCDFBlockerActionMap[action]
}
